import { Screen } from './types';

/** Path builders for app navigation. */
export const paths = {
  dashboard: () => '/' as const,
  brandManage: () => '/brands' as const,
  brandSelect: () => '/brands/select' as const,
  wizard: (brandId: string) => `/brands/${encodeURIComponent(brandId)}/new` as const,
  editor: (brandId: string, projectId: string) =>
    `/brands/${encodeURIComponent(brandId)}/project/${encodeURIComponent(projectId)}` as const,
  settings: () => '/settings' as const,
};

export interface RouteMatch {
  screen: Screen;
  brandId?: string;
  projectId?: string;
  isSelectionMode?: boolean;
}

/**
 * Derive screen and params from pathname (no Route params needed).
 * Invalid or unknown paths return DASHBOARD (caller can redirect).
 */
export function parseRoute(pathname: string): RouteMatch {
  const normalized = pathname.replace(/\/+/g, '/').replace(/\/$/, '') || '/';
  const segments = normalized.split('/').filter(Boolean);

  if (normalized === '/') return { screen: Screen.DASHBOARD };
  if (normalized === '/brands') return { screen: Screen.BRAND_SELECT, isSelectionMode: false };
  if (normalized === '/brands/select') return { screen: Screen.BRAND_SELECT, isSelectionMode: true };
  if (normalized === '/settings') return { screen: Screen.SETTINGS };

  // /brands/:brandId/new
  if (segments[0] === 'brands' && segments[1] && segments[2] === 'new') {
    return { screen: Screen.WIZARD_INPUT, brandId: decodeURIComponent(segments[1]) };
  }

  // /brands/:brandId/project/:projectId
  if (segments[0] === 'brands' && segments[1] && segments[2] === 'project' && segments[3]) {
    return {
      screen: Screen.EDITOR,
      brandId: decodeURIComponent(segments[1]),
      projectId: decodeURIComponent(segments[3]),
    };
  }

  return { screen: Screen.DASHBOARD };
}
